"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLAIMS = void 0;
exports.CLAIMS = {
    EMAIL: "https://www.arnoldclark.com/email",
    ACCOUNTID: "https://www.arnoldclark.com/accountId"
};
//# sourceMappingURL=constants.js.map